<template>
  <div>
    <el-form ref="form" size="small" :model="formData" label-position="top">
      <div class="d-flex">
        <div class="d-flex" style="margin-right: 10px;">
          <el-avatar shape="square" :src="formData.bigImageUrl" :size="64">
            <span style="font-size: 20px;">LOGO</span>
          </el-avatar>
        </div>
        <el-row :gutter="10" class="flex-grow-1">
          <el-col :span="6">
            <el-form-item :label="$l('form_label_custNo') || '客户编号'">
              <el-input v-model="formData.custNo" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$l('form_label_custShortName') || '客户简称'">
              <el-input v-model="formData.custShortName" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_custName') || '客户公司名称'">
              <el-input v-model="formData.custName" readonly />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$l('form_label_depNo') || '部门编号'">
            <el-input v-model="formData.depNo" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item :label="$l('form_label_depFullName') || '部门全称'">
            <el-input v-model="formData.depFullName" readonly />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$l('form_label_orgNo') || '机构编号'">
            <el-input v-model="formData.orgNo" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item :label="$l('form_label_orgName') || '机构名称'">
            <el-input v-model="formData.orgName" readonly />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: { costSectorCode: { type: String, default: '' } },
  data() {
    return { formData: {} }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.costSectorCode) return
      const res = await this.$api
        .masterCustomerCostSectorDetailApi({
          costSectorCode: this.costSectorCode,
        })
        .catch(() => null)

      this.formData = res?.body
    },
  },
}
</script>
